<p class="title">
    <img class="icon-title" src="assets/images/add_circle_outline.svg" alt="Image" />
    {{ texts.titulo }}
</p>
<div class="container">
    <div id="mainDiv" class="main-div form-div">
        <div class="form-row">
            <div class="input-group">
                <label>{{ labels.nome }}</label>
                <input type="text" pInputText [placeholder]="placeholders.nome" [(ngModel)]="form.nome" />
            </div>
            <div class="input-group">
                <label>{{ labels.codigo }}</label>
                <input type="number" pInputText [placeholder]="placeholders.codigo" [(ngModel)]="form.codigo" />
            </div>
        </div>
        <div class="actions-container">
            <button pButton [label]="botoes.enviar" icon="pi pi-check" (click)="submit()" class="btn-primary"></button>
        </div>
    </div>
</div>
